export default __webpack_public_path__ + "static/media/help.5dda2a9c.svg";